import React from 'react';

export default function Modal({ open, title, children, actions, onClose, size = 'md' }) {
  const titleId = React.useId();

  React.useEffect(() => {
    if (!open) return;
    const handleKey = (event) => {
      if (event.key === 'Escape' && onClose) {
        onClose();
      }
    };
    document.body.classList.add('modal-open');
    document.addEventListener('keydown', handleKey);
    return () => {
      document.body.classList.remove('modal-open');
      document.removeEventListener('keydown', handleKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className={`modal modal-${size}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-header">
          {title ? <h2 id={titleId}>{title}</h2> : <span />}
          {onClose ? (
            <button className="btn btn-ghost btn-sm" type="button" onClick={onClose}>
              Close
            </button>
          ) : null}
        </div>
        <div className="modal-body">{children}</div>
        {actions ? <div className="modal-actions">{actions}</div> : null}
      </div>
    </div>
  );
}
